import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { AudioFile, File, Section, SectionStatus, AudioFileRule, AudioFileNumberOfReplays } from '../../../../core';
export var SectionApiMapper = /*#__PURE__*/function () {
  function SectionApiMapper() {
    _classCallCheck(this, SectionApiMapper);
  }

  _createClass(SectionApiMapper, [{
    key: "toDomain",
    value: function toDomain(formId, sectionDto) {
      return Section.create({
        id: sectionDto.id,
        title: sectionDto.title,
        description: sectionDto.description,
        formId: formId,
        status: SectionStatus.Activate,
        previousSectionId: sectionDto.previousSectionId,
        parentSectionId: sectionDto.parentSectionId,
        files: sectionDto.files.map(function (f) {
          return File.create({
            url: f.url,
            type: f.type,
            size: f.size
          }, f.id).getValue();
        }),
        audioFile: sectionDto.audioFile ? AudioFile.create({
          url: sectionDto.audioFile.url,
          type: sectionDto.audioFile.type,
          size: sectionDto.audioFile.size,
          rule: sectionDto.audioFile.rule ? AudioFileRule.create(_objectSpread(_objectSpread({}, sectionDto.audioFile.rule), {}, {
            numberOfReplays: AudioFileNumberOfReplays.create(sectionDto.audioFile.rule.numberOfReplays).getValue()
          })).getValue() : undefined
        }, sectionDto.audioFile.id).getValue() : undefined
      }).getValue();
    }
  }, {
    key: "fromDomain",
    value: function fromDomain(section) {
      return {
        id: section.id.toString(),
        title: section.title,
        description: section.description,
        previousSectionId: section.previousSectionId,
        parentSectionId: section.parentSectionId,
        files: section.files.map(function (f) {
          return {
            id: f.id.toString(),
            url: f.url,
            type: f.type,
            size: f.size
          };
        }),
        audioFile: section.audioFile ? {
          id: section.audioFile.id.toString(),
          url: section.audioFile.url,
          type: section.audioFile.type,
          size: section.audioFile.size,
          rule: {
            numberOfReplays: section.audioFile.rule.numberOfReplays.value,
            isAutoPlay: section.audioFile.rule.isAutoPlay,
            allowingToPauseAndStop: section.audioFile.rule.allowingToPauseAndStop,
            isAllowedToReplay: section.audioFile.rule.isAllowedToReplay
          }
        } : null
      };
    }
  }]);

  return SectionApiMapper;
}();